import React, { useEffect, useState } from 'react';

import { Collapse } from 'antd';
import ProjectDetailsForm from './ProjectDetailsForm';

import { post } from 'api';
import { spinnerOff, spinnerOn } from 'components/Spinner';
import AddProjectForm from './AddProjectForm';
const { Panel } = Collapse;

function NewDataTrackerTabContainer({
  history,
  context,
}) {

  const [projectExist, setProjectExist] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [project, setProject] = useState(null)
  const [newProject, setNewProject] = useState(null)
  const [isEditModelOpen, setEditModel] = useState(false)
  const [stations, setStation] = useState([]);
  const [addDTStatus, setAddDTStatus] = useState(null);


  const handleCancel = () => {
    setIsModalOpen(false)
  }


  async function addNewProject(formData) {

    if (formData.bpid) {
      spinnerOn();
      const result = await post(`ipsprojects/addnew`, '', formData);
      setProject(result.data);
      setAddDTStatus(result.statusMsg)
      spinnerOff();
      if (result.data && (result.statusMsg === 'DATATRACKER_RECORD_FOUND' || result.statusMsg === 'TCL_PROJECT_FOUND')) {
        setProjectExist(true)
        setIsModalOpen(true)

      } else {
        setProjectExist(false)
        if (result.status === 'SUCCESS') {
          history.push(`/datatracker_progress/${result.data.stationName}/${result.data.bpid}/${result.data.workOrder}/details`);
        }
      }
    }
  }

  const goToProject = () => {

    history.push(`/datatracker_progress/${project.stationName}/${project.bpid}/${project.workOrder}/details`);

  }
  const ExtraText = () => {
    return <span style={{ fontSize: 14, color: 'red' }} onClick={() => { setIsModalOpen(true) }}>the same BPID.  Click here to review the data</span>
  }

  return (
    <>

      <Collapse
        defaultActiveKey={['1']}
        activeKey={['1']}
        className='site-collapse-custom-collapse'
      >
        <Panel
          header={'Project Details'}
          key='1'
          className='site-collapse-custom-panel'
        // extra={projectExist && <ExtraText />}
        >
          <AddProjectForm
            history={history}
            context={context}
            setProjectExist={setProjectExist}
            setProject={setProject}
            setNewProject={setNewProject}
            addNewProject={addNewProject}
            project={newProject}
            goToProject={goToProject}
            isModalOpen={isModalOpen}
            handleCancel={handleCancel}
          />
        </Panel>

      </Collapse>
    </>
  );
}

export default NewDataTrackerTabContainer;
